import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Nav from './Nav/Nav'
import Insights from './Insights/Index'
class InsightsInfo extends Component {
  render () {
    return (
      <MuiThemeProvider>
        <div className="insights-info">
          <Nav
            params={this.props.match.params}
            rootStyle={{
              height: '52px'
            }}
            liStyle={{
              height: '52px',
              lineHeight: '52px'
            }}
          />
          {this.props.match.params.type === 'insights' && (
            <Insights {...this.props}/>
          )}
        </div>
      </MuiThemeProvider>
    )
  }
}

export default InsightsInfo;



// WEBPACK FOOTER //
// ./src/components/InsightsInfo/Index.jsx